import * as React from 'react';
import { Box } from '@mui/material';
import { useReactiveVar } from '@apollo/client';
import { keycloak, KeycloakRoles } from '@coverright/shared/keycloak';
import { AgentSelector } from '../../features';
import { AgentOutput } from '@coverright/data-access/types/enrollment';
import { ListPageWrapper, PageTitle } from '../../shared';
import { hasUrgentToolbar } from '../../app/ui/urgent-notifications/urgent-notifications';
import { CalendarView } from './ui/calendar-view';

const isManagerOrAdmin = () =>
  keycloak?.hasRealmRole(KeycloakRoles.ROLE_AGENT_MANAGER);

export const Calendar = () => {
  const hasToolbar = useReactiveVar(hasUrgentToolbar);
  const contextEmail: string | undefined =
    keycloak?.tokenParsed?.email || keycloak?.tokenParsed?.preferred_username;
  const contextAgentId: string | undefined = keycloak?.tokenParsed?.sub;

  const canViewOthers = isManagerOrAdmin();
  const [selectedAgent, setSelectedAgent] = React.useState<AgentOutput | undefined>(undefined);

  // Only pass agentEmail when a manager is explicitly viewing a different agent's calendar.
  // Non-managers (and managers on their own calendar) pass null so the backend uses the JWT identity,
  // which avoids the non-null schema error thrown when agentEmail is provided without manager role.
  const agentEmail = canViewOthers && selectedAgent ? selectedAgent.email : null;

  return (
    <ListPageWrapper sx={{
      height: `calc(100vh - ${hasToolbar ? 46 : 16}px)`,
      overflow: 'hidden',
    }}>
      <PageTitle title="Calendar">
        {canViewOthers && (
          <Box sx={{ width: 240 }}>
            <AgentSelector
              value={selectedAgent?.id ?? contextAgentId}
              onChange={() => {}}
              onChangeAgent={(agent) => setSelectedAgent(agent || undefined)}
              label="View calendar for"
            />
          </Box>
        )}
      </PageTitle>

      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <CalendarView agentEmail={agentEmail} ownEmail={contextEmail} isOwnCalendar={!canViewOthers || !selectedAgent} key={agentEmail ?? contextEmail} />
      </Box>
    </ListPageWrapper>
  );
};
